export const ERROR_BANNER_NS = 'components/ErrorBanner';

export const i18n = {
  en: {
    title: 'Unable to connect to live data.',
    action: {
      retry: 'retry',
    },
    message: {
      prefix: 'Please',
      suffix: 'the connection',
    },
  },
};
